import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { BadgeFormModule } from 'src/app/components/badge-form/badge-form.module';
import { PaymentResponseMessageFormModule } from 'src/app/components/payment-response-message-form/payment-response-message-form.module';
import { PaymentResponseMessageTypeFormModule } from 'src/app/components/payment-response-message-type-form/payment-response-message-type-form.module';
import { AppTableModule } from 'src/app/components/table/app-table.module';
import { ContentRoutingModule } from '../content/content-routing.module';
import { BadgeDetailsComponent } from './badge-details/badge-details.component';
import { BadgeComponent } from './badge/badge.component';
import { PaymentResponseMessageDetailComponent } from './payment-response-message-detail/payment-response-message-detail.component';
import { PaymentResponseMessageTypeDetailComponent } from './payment-response-message-type-detail/payment-response-message-type-detail.component';
import { PaymentResponseMessageTypeComponent } from './payment-response-message-type/payment-response-message-type.component';
import { PaymentResponseMessageComponent } from './payment-response-message/payment-response-message.component';
import { CardUpdaterComponent } from './card-updater/card-updater.component';
import { CardVerificationComponent } from './card-verification/card-verification.component';
import { CheckoutGatewayPriorityComponent } from './checkout-gateway-priority/checkout-gateway-priority.component';
import { CheckoutJourneyCollectorComponent } from './checkout-journey-collector/checkout-journey-collector.component';
import { MercadoPagoRetentionThreeDsComponent } from './mercadopago-retention-3ds/mercadopago-retention-3ds.component';
import { PixComponent } from './pix/pix.component';
import { SubscriptionSettingsRoutingModule } from './subscription-settings-routing.module';
import { SubscriptionTypeDetailsComponent } from './subscription-types/subscription-type-details/subscription-type-details.component';
import { SubscriptionTypePriceFormModalComponent } from './subscription-types/subscription-type-details/subscription-type-price-form-modal/subscription-type-price-form-modal.component';
import { SubscriptionTypesComponent } from './subscription-types/subscription-types.component';

@NgModule({
  declarations: [
    BadgeComponent,
    BadgeDetailsComponent,
    SubscriptionTypesComponent,
    SubscriptionTypeDetailsComponent,
    SubscriptionTypePriceFormModalComponent,
    PixComponent,
    CardVerificationComponent,
    CardUpdaterComponent,
    MercadoPagoRetentionThreeDsComponent,
    CheckoutJourneyCollectorComponent,
    CheckoutGatewayPriorityComponent,
    PaymentResponseMessageComponent,
    PaymentResponseMessageDetailComponent,
    PaymentResponseMessageTypeComponent,
    PaymentResponseMessageTypeDetailComponent
  ],
  imports: [
    CommonModule,
    SubscriptionSettingsRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    BadgeFormModule,
    AppTableModule,
    ButtonModule,
    InputTextModule,
    TabViewModule,
    ToastModule,
    ConfirmPopupModule,
    BadgeFormModule,
    DropdownModule,
    CalendarModule,
    ContentRoutingModule,
    OverlayPanelModule,
    InputTextareaModule,
    InputNumberModule,
    AutoFocusModule,
    ConfirmDialogModule,
    InputSwitchModule,
    FileUploadModule,
    AccordionModule,
    PaymentResponseMessageTypeFormModule,
    PaymentResponseMessageFormModule,
    TooltipModule,
    NgxPermissionsModule.forChild()
  ],
  providers: [MessageService, ConfirmationService]
})
export class SubscriptionSettingsModule {}
